import { render, staticRenderFns } from "./personDetail.vue?vue&type=template&id=0d924dce&scoped=true"
import script from "./personDetail.vue?vue&type=script&lang=js"
export * from "./personDetail.vue?vue&type=script&lang=js"
import style0 from "./personDetail.vue?vue&type=style&index=0&id=0d924dce&prod&lang=scss&scoped=true"
import style1 from "./personDetail.vue?vue&type=style&index=1&id=0d924dce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d924dce",
  null
  
)

export default component.exports